import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import PageLoader from '@/ebat/components/blocks/PageLoader/PageLoader';

import CheckoutConfirm from './CheckoutConfirm';
import useCheckoutConfirmContainer from './useCheckoutConfirm.container';

const CheckoutConfirmContainer = () => {
  const { t } = useTranslation();

  const {
    company,
    isDisabled,
    order,
    warehouse,
  } = useCheckoutConfirmContainer();

  if (isDisabled.loading) {
    return <PageLoader className="scanbat-checkout-confirm-page" />;
  }

  return (
    <>
      <Helmet>
        <title>
          {`${t('ebat:entities:scanbat.checkout_confirm.title')} - ${t(
            'ebat:messages:scanbat.title',
          )}`}
        </title>
      </Helmet>
      <main className="main scanbat-checkout-confirm-page">
        <CheckoutConfirm
          company={company}
          disabled={isDisabled.disabled}
          isLoading={isDisabled.loading}
          order={order}
          warehouse={warehouse}
        />
      </main>
    </>
  );
};

export default CheckoutConfirmContainer;
